var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"xt"},[_c('h1',[_vm._v("请关闭浏览器以完成注销")]),_c('router-link',{staticStyle:{"color":"black"},attrs:{"to":{ path: '/login' }}},[_vm._v(" 返回网站 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }